import Paper from '@mui/material/Paper';

import { styled } from '@mui/material/styles';

export const OptionsPaper = styled(Paper, {
  label: 'OptionsPaper',
})(() => ({
  position: 'fixed',
  marginTop: 3,
  zIndex: 99,
  overflowY: 'auto',
}));

export const OptionTextRuler = styled('div', {
  label: 'OptionTextRuler',
})(({ theme }) => ({
  padding: theme.spacing(0, 3),
  height: 0,
  position: 'absolute',
  top: 0,
  left: 0,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
}));

export const OptionText = styled('span', {
  label: 'OptionText',
})(() => ({
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  unicodeBidi: 'plaintext',
}));

export const OptionHintRoot = styled('div', {
  label: 'OptionHintRoot',
})(() => ({
  position: 'fixed',
  zIndex: 9999,
  maxWidth: 400,
  pointerEvents: 'none',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const OptionHintText = styled('div', {
  label: 'OptionHintRoot',
})(({ theme }) => ({
  width: '100%',
  height: '100%',
  zIndex: 1,
  color: theme.palette.common.white,
  fontSize: 11,
  backgroundColor: theme.palette.grey[800],
  padding: 8,
  wordBreak: 'break-word',
  borderRadius: 4,
}));

export const OptionHintArrow = styled('div', {
  label: 'OptionHintArrow',
})(({ theme }) => ({
  position: 'absolute',
  left: 'calc( 50% - 10px )',
  bottom: '-4px',
  transform: 'rotate(45deg)',
  border: `10px solid ${theme.palette.grey[800]}`,
}));
